// Central site configuration — swap these values freely.

// Visible brand name (used sitewide).
export const BRAND_NAME = "Word Amp";

// Live demo link. Set this to your working demo URL.
export const DEMO_URL = "https://demo.wordamp.com";

// Contact email used in footer mailto link.
export const CONTACT_EMAIL = "hello@wordamp.app";

// Legal / attribution line.
export const LEGAL_LINE = "A Word Amp LLC project";
